import { render, staticRenderFns } from "./cancelAppointment.vue?vue&type=template&id=6afdb8a5&scoped=true&"
import script from "./cancelAppointment.vue?vue&type=script&lang=js&"
export * from "./cancelAppointment.vue?vue&type=script&lang=js&"
import style0 from "./cancelAppointment.vue?vue&type=style&index=0&id=6afdb8a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afdb8a5",
  null
  
)

export default component.exports